import React from "react";

export const check = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 54.8938L0 34.8938L8.89378 26L20 37.1376L51.1062 6L60 14.8938L20 54.8938Z"
        fill="currentColor"
      />
    </svg>
  );
};
